import { render, staticRenderFns } from "./FormResearch3.vue?vue&type=template&id=2c409beb&scoped=true"
import script from "./FormResearch3.vue?vue&type=script&lang=js"
export * from "./FormResearch3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c409beb",
  null
  
)

export default component.exports